import { render, staticRenderFns } from "./teacherAdd.vue?vue&type=template&id=6365e775&scoped=true&"
import script from "./teacherAdd.vue?vue&type=script&lang=js&"
export * from "./teacherAdd.vue?vue&type=script&lang=js&"
import style0 from "./teacherAdd.vue?vue&type=style&index=0&id=6365e775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365e775",
  null
  
)

export default component.exports